import { Logger as ApiLogger } from '@alme/types/logging/Logger';
import { isDebug } from './utils/DebugUtils';

export type Logger = ApiLogger;

export enum UiLogLevel {
    FATAL = 1,
    ERROR = 2,
    WARN = 3,
    INFO = 4,
    DEBUG = 5,
    ALL = 6,
}

export class ConsoleLogger implements Logger {
    private static instance: ConsoleLogger;
    public loggingLevel: UiLogLevel;

    private constructor(loggingLevel: UiLogLevel) {
        this.loggingLevel = loggingLevel;
    }

    static getInstance(loggingLevel: UiLogLevel): ConsoleLogger {
        if (!ConsoleLogger.instance) {
            ConsoleLogger.instance = new ConsoleLogger(loggingLevel);
        }

        ConsoleLogger.instance.loggingLevel = loggingLevel;
        return ConsoleLogger.instance;
    }

    error(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.loggingLevel >= 1) {
            console.error(message, ...optionalParams);
        }
    }

    warn(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.loggingLevel >= 3) {
            console.warn(message, ...optionalParams);
        }
    }

    info(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.loggingLevel >= 4) {
            console.info(message, ...optionalParams);
        }
    }

    debug(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.loggingLevel >= 5) {
            console.debug(message, ...optionalParams);
        }
    }

    log(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.loggingLevel >= 6) {
            console.log(message, ...optionalParams);
        }
    }
}

let defaultLevel: UiLogLevel = 3;
if (isDebug()) {
    defaultLevel = UiLogLevel.ALL;
}

export default ConsoleLogger.getInstance(defaultLevel);

export const defaultLogLevel = defaultLevel;